
import { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Share2, Twitter } from 'lucide-react';
import { toast } from "sonner";

interface InitiationSocialProps {
  onComplete: (data: { socialShared: boolean }) => void;
  userData?: any;
}

const InitiationSocial = ({ onComplete, userData }: InitiationSocialProps) => {
  const [isSharing, setIsSharing] = useState(false);

  const brocode = userData?.brocode || userData?.rank || '';
  const brocodeText = brocode ? ` My BroCode: ${brocode}` : '';
  const shareText = `Just joined the BroMentum movement! 🚀 Building a decentralized future with $BRO.${brocodeText}\n\n#BroMentum #DeFi #Web3 @bromentum_club`;

  const handleTwitterShare = () => {
    const tweetUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`;
    window.open(tweetUrl, '_blank');
  };


  const handleCompleteSharing = async () => {
    setIsSharing(true);
    
    try {
      // FIXED: Users should only proceed, actual verification happens later in the flow
      // This step only tracks that they attempted social sharing
      toast.success('Social sharing step completed! Points will be awarded after verification.');
      
      onComplete({
        socialShared: true
      });
      
    } catch (error) {
      console.error('Sharing completion error:', error);
      toast.error('Failed to complete sharing. Please try again.');
    } finally {
      setIsSharing(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <Share2 className="mx-auto mb-4 text-tan" size={48} />
        <h3 className="text-xl font-bold text-tan mb-2">Share & Earn</h3>
        <p className="text-tan-dark">
          Share your BroMentum journey on social media to earn bonus points
        </p>
      </div>

      <div className="space-y-4">
        <div className="bg-navy-dark p-4 rounded-lg">
          <h4 className="text-tan font-medium mb-2">Share this message:</h4>
          <p className="text-sm text-tan-dark bg-navy p-3 rounded border-l-4 border-tan">
            {shareText}
          </p>
        </div>
        
        <div className="flex gap-3">
          <Button 
            onClick={handleTwitterShare}
            variant="outline"
            className="flex-1 border-blue-400 text-blue-400 hover:bg-blue-400 hover:text-white"
          >
            <Twitter size={16} className="mr-2" />
            Share on Twitter
          </Button>
        </div>
        
        <div className="bg-navy-dark p-4 rounded-lg">
          <p className="text-sm text-tan-dark">
            💡 <strong>Important:</strong> You must actually post the tweet to earn BroScore. Verification will happen in the next step.
          </p>
        </div>
        
        <Button 
          onClick={handleCompleteSharing}
          disabled={isSharing}
          className="w-full bg-tan text-navy hover:bg-tan-dark"
        >
          {isSharing ? 'Processing...' : "Continue (Verification Required)"}
        </Button>
      </div>
    </div>
  );
};

export default InitiationSocial;
